export const ChevronDownIcon = () => (
  <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M15 8.08711L13.825 6.91211L10 10.7288L6.175 6.91211L5 8.08711L10 13.0871L15 8.08711Z' fill='currentColor' />
  </svg>
)
